import { NetworkStrength4CogIcon } from './NetworkStrength4CogIcon';

/**
 * author: Michael Irigoyen
 * id AB7248F1-C9F3-4EF3-ACD5-8B7EE11771C3
 * name network-strength-4-cog
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-4-cog.svg
 * tags
 * - Settings 
 */
export const NetworkStrength4SettingsIcon = NetworkStrength4CogIcon;
export default NetworkStrength4SettingsIcon